/**
 * Resolves the rendering state of the data visualization page.
 * Uses a Record-based dispatch instead of nested ternaries.
 */
export type ViewState = "loading" | "gone" | "ready" | "empty";

interface ResolveArgs {
  isLoading: boolean;
  isError: boolean;
  errorStatus?: number;
  hasData: boolean;
}

export function resolveViewState({
  isLoading,
  isError,
  errorStatus,
  hasData,
}: ResolveArgs): ViewState {
  if (isLoading) return "loading";
  if (isError && errorStatus === 410) return "gone";
  if (hasData) return "ready";
  return "empty";
}
